/**
 * Číselník stavů objednávky — zrcadlo `App\Support\StavObjednavky`.
 * Server posílá u řádku `kategorie` hotovou; tohle je pro místa, kde přijde
 * jen text stavu (historie stavů, WebSocket). Měnit obojí.
 */
export const KATEGORIE = {
    hotova: { label: 'Hotová', poradi: 3 },
    rozpracovana: { label: 'Rozpracovaná', poradi: 1 },
    ceka_platba: { label: 'Čeká na platbu', poradi: 2 },
    otevrena: { label: 'Otevřený účet', poradi: 2 },
    storno: { label: 'Storno', poradi: 4 },
    nahrazena: { label: 'Nahrazená', poradi: 5 },
    // Objednávka na čas — jen naplánovaná, do čísel dne se počítá až po potvrzení
    odlozena: { label: 'Odložená', poradi: 0 },
};

export const PLATNE = ['hotova', 'rozpracovana'];

export function kategorie(stav) {
    const s = String(stav || '').toLowerCase().trim();
    if (s.includes('upraven') && s.includes('↪')) return 'nahrazena';
    if (s.includes('storn')) return 'storno';
    if (s.includes('čeká na platbu') || s.includes('ceka na platbu')) return 'ceka_platba';
    if (s === 'otevřená' || s === 'otevrena') return 'otevrena';
    if (s === 'hotová' || s === 'hotova') return 'hotova';
    if (s === 'odložená' || s === 'odlozena') return 'odlozena';
    return 'rozpracovana';
}

/** Text stavu pro lidi: „stornovaná (upravená) ↪ 00034825" → „Storno · nahrazena 00034825". */
export function popisStavu(stav) {
    const s = String(stav || '').trim();
    if (!s) return '—';
    const nahrazena = /upraven\S*\)\s*↪\s*(\S+)/i.exec(s);
    if (nahrazena) return `Nahrazena objednávkou ${nahrazena[1]}`;
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Kde objednávka zrovna je — průběh z OS (`prubeh`: Nová → Potvrzená →
 * V kuchyni → Čeká na rozvoz → Na cestě → Hotová), jinak uložený stav.
 */
export function popisObjednavky(o) {
    return o?.prubeh?.popis || popisStavu(o?.stav);
}

/** Je objednávka hotová? Průběh má přednost — rozvoz zaplacený předem jede dál. */
export function jeHotova(o) {
    return o?.prubeh ? o.prubeh.kod === 'hotova' : o?.kategorie === 'hotova';
}
